import * as React from 'react';
import { FormFastField } from '~/Partials/FormFields/FormFastField';
import type { FormFieldValidate } from '~/Partials/FormFields/validators';
import type { BookMeetingCalendarProps } from './BookMeetingCalendar';
import { BookMeetingCalendar } from './BookMeetingCalendar';

interface BookMeetingCalendarWithFormikProps extends Pick<BookMeetingCalendarProps, 'translations' | 'name'> {
    validate?: FormFieldValidate<string>;
    validateFieldOnFieldChange?: boolean;
    validateFieldOnFieldBlur?: boolean;
    onAfterBlur?: (val: string) => void;
}

export const BookMeetingCalendarWithFormik: React.FC<BookMeetingCalendarWithFormikProps> = props => {
    const { name, validate, onAfterBlur, validateFieldOnFieldBlur, validateFieldOnFieldChange, translations } = props;

    return (
        <FormFastField
            validate={validate}
            name={name}
            onAfterBlur={onAfterBlur}
            validateFieldOnFieldBlur={validateFieldOnFieldBlur}
            validateFieldOnFieldChange={validateFieldOnFieldChange}
        >
            {fieldProps => {
                const { inputProps, showError, errorMessage } = fieldProps;
                const { value, ...restInputProps } = inputProps;

                return (
                    <BookMeetingCalendar
                        {...restInputProps}
                        translations={translations}
                        errorMessage={errorMessage}
                        showErrorMessage={showError}
                        value={value ? new Date(value) : null}
                        required={!!validate}
                    />
                );
            }}
        </FormFastField>
    );
};
